import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useReveal, useFloatBtn } from '../components/hooks';
import Footer from '../components/Footer';
import './Testimonials.css';

const allTestimonials = [
  { initials:'SR', name:'Sophie R., 28', detail:'IGNITE · Online · Body Recomp', pkg:'ignite', goal:'recomp', gender:'female', stars:'★★★★★', quote:'"I was scared of \'getting bulky\'. Liam completely rewired how I think about training. I lost fat, built shape, and now actually enjoy going to the gym for the first time ever."', stats:[{n:'−10kg',l:'Lost'},{n:'+5kg',l:'Muscle'},{n:'−8%',l:'Body Fat'}], duration:'16 Weeks' },
  { initials:'DK', name:'Daniel K., 41', detail:'FORGE · In-Person & Online', pkg:'forge', goal:'fatloss', gender:'male', stars:'★★★★★', quote:'"Previous coaches gave me cookie-cutter plans. Liam built everything from scratch. The WhatsApp support kept me going through weeks I would\'ve quit. Down 22lbs, lowest body fat of my adult life."', stats:[{n:'−20kg',l:'Lost'},{n:'−14%',l:'Body Fat'},{n:'8wk',l:'Duration'}], duration:'8 Weeks' },
  { initials:'AL', name:'Amanda L., 47', detail:'FORGE · Online · Full Recomp', pkg:'forge', goal:'recomp', gender:'female', stars:'★★★★★', quote:'"I\'m 47 years old and genuinely in the best shape of my life. The mindset coaching was unexpected — but it changed everything. Liam treats you like an actual person."', stats:[{n:'Full',l:'Recomp'},{n:'−7%',l:'Body Fat'},{n:'+4kg',l:'Muscle'}], duration:'20 Weeks' },
  { initials:'TC', name:'Tom C., 32', detail:'IGNITE → FORGE', pkg:'ignite', goal:'muscle', gender:'male', stars:'★★★★★', quote:'"Started with IGNITE to test the water — honestly I should have jumped straight to FORGE. The quality of the plan blew me away for the price. Now on FORGE and the results have gone through the roof."', stats:[{n:'−10kg',l:'Lost'},{n:'+7kg',l:'Muscle'},{n:'24wk',l:'Duration'}], duration:'24 Weeks' },
  { initials:'MK', name:'Mark K., 38', detail:'IGNITE · Home Training', pkg:'ignite', goal:'fatloss', gender:'male', stars:'★★★★★', quote:'"The weekly check-ins kept me honest. Having a proper plan finally got me results after years of spinning my wheels. The nutrition plan is incredible."', stats:[{n:'−8kg',l:'Lost'},{n:'−6%',l:'Body Fat'},{n:'12wk',l:'Duration'}], duration:'12 Weeks' },
  { initials:'ER', name:'Emma R., 25', detail:'IGNITE · Online', pkg:'ignite', goal:'muscle', gender:'female', stars:'★★★★★', quote:'"As a woman who had never properly lifted before, I was intimidated. Liam made it so straightforward. Eight weeks in and I\'m already seeing abs for the first time in my life."', stats:[{n:'+4kg',l:'Muscle'},{n:'−5%',l:'Body Fat'},{n:'8wk',l:'Duration'}], duration:'8 Weeks' },
  { initials:'BT', name:'Ben T., 29', detail:'FORGE · Online', pkg:'forge', goal:'fatloss', gender:'male', stars:'★★★★★', quote:'"The WhatsApp access on FORGE is a game changer. Liam is genuinely invested in your results — you can feel it. I hit my target weight for the first time in 5 years."', stats:[{n:'−15kg',l:'Lost'},{n:'−10%',l:'Body Fat'},{n:'16wk',l:'Duration'}], duration:'16 Weeks' },
  { initials:'LH', name:'Lucy H., 35', detail:'FORGE · In-Person & Online', pkg:'forge', goal:'recomp', gender:'female', stars:'★★★★★', quote:'"I tried IGNITE for three months then upgraded to FORGE — the video calls and WhatsApp support are on a different level. Liam genuinely knows his stuff and actually cares about your progress."', stats:[{n:'Full',l:'Recomp'},{n:'+6kg',l:'Muscle'},{n:'−9%',l:'Body Fat'}], duration:'20 Weeks' },
];

function BaSlider({ before, after }) {
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);
  const sliderRef = useRef(null);

  const setFromClient = (clientX) => {
    const rect = sliderRef.current.getBoundingClientRect();
    const pct = Math.max(2, Math.min(98, ((clientX - rect.left) / rect.width) * 100));
    setPos(pct);
  };

  useEffect(() => {
    const onMove = e => { if (dragging.current) setFromClient(e.clientX || e.touches?.[0]?.clientX); };
    const onUp = () => { dragging.current = false; };
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchmove', onMove, { passive: true });
    window.addEventListener('touchend', onUp);
    return () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('touchend', onUp);
    };
  }, []);

  return (
    <div className="ba-slider" ref={sliderRef}
      onMouseDown={e => { dragging.current = true; setFromClient(e.clientX); e.preventDefault(); }}
      onTouchStart={e => { dragging.current = true; setFromClient(e.touches[0].clientX); }}>
      <div className="ba-before">{before}</div>
      <div className="ba-after" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>{after}</div>
      <div className="ba-lbl b">Before</div>
      <div className="ba-lbl a">After</div>
      <div className="ba-line" style={{ left: `${pos}%` }}></div>
      <div className="ba-handle" style={{ left: `${pos}%` }}><div className="ba-handle-inner">⇔</div></div>
    </div>
  );
}

const maleBefore = (w) => (
  <svg viewBox="0 0 120 180" width="90%" height="90%" preserveAspectRatio="xMidYMid meet">
    <defs><radialGradient id="skinM"><stop offset="0%" stopColor="#c8956c"/><stop offset="100%" stopColor="#a0684a"/></radialGradient></defs>
    <ellipse cx="60" cy="50" rx="24" ry="26" fill="url(#skinM)"/>
    <ellipse cx="60" cy="118" rx="40" ry="48" fill="#2a2020" opacity=".9"/>
    <ellipse cx="60" cy="82" rx="38" ry="28" fill="#252020"/>
    <text x="60" y="168" textAnchor="middle" fontFamily="sans-serif" fontSize="9" fill="#666">{w}</text>
  </svg>
);
const maleAfter = (w) => (
  <svg viewBox="0 0 120 180" width="90%" height="90%" preserveAspectRatio="xMidYMid meet">
    <defs><radialGradient id="skinM2"><stop offset="0%" stopColor="#c8956c"/><stop offset="100%" stopColor="#a0684a"/></radialGradient></defs>
    <ellipse cx="60" cy="49" rx="21" ry="23" fill="url(#skinM2)"/>
    <ellipse cx="60" cy="113" rx="30" ry="42" fill="#241a08" opacity=".9"/>
    <ellipse cx="60" cy="79" rx="30" ry="24" fill="#201808"/>
    <line x1="52" y1="83" x2="52" y2="97" stroke="rgba(201,169,110,.4)" strokeWidth="1.5"/>
    <line x1="60" y1="81" x2="60" y2="99" stroke="rgba(201,169,110,.4)" strokeWidth="1.5"/>
    <line x1="68" y1="83" x2="68" y2="97" stroke="rgba(201,169,110,.4)" strokeWidth="1.5"/>
    <text x="60" y="168" textAnchor="middle" fontFamily="sans-serif" fontSize="9" fill="#c9a96e">{w}</text>
  </svg>
);
const femaleBefore = (w) => (
  <svg viewBox="0 0 120 180" width="90%" height="90%" preserveAspectRatio="xMidYMid meet">
    <defs><radialGradient id="skinF"><stop offset="0%" stopColor="#d4a079"/><stop offset="100%" stopColor="#b07855"/></radialGradient></defs>
    <ellipse cx="60" cy="52" rx="22" ry="24" fill="url(#skinF)"/>
    <ellipse cx="60" cy="120" rx="36" ry="46" fill="#2a2020" opacity=".9"/>
    <ellipse cx="60" cy="85" rx="34" ry="26" fill="#252020"/>
    <text x="60" y="168" textAnchor="middle" fontFamily="sans-serif" fontSize="9" fill="#666">{w}</text>
  </svg>
);
const femaleAfter = (w) => (
  <svg viewBox="0 0 120 180" width="90%" height="90%" preserveAspectRatio="xMidYMid meet">
    <defs><radialGradient id="skinF2"><stop offset="0%" stopColor="#d4a079"/><stop offset="100%" stopColor="#b07855"/></radialGradient></defs>
    <ellipse cx="60" cy="50" rx="20" ry="22" fill="url(#skinF2)"/>
    <ellipse cx="60" cy="115" rx="26" ry="40" fill="#241a08" opacity=".9"/>
    <ellipse cx="60" cy="80" rx="26" ry="22" fill="#201808"/>
    <line x1="54" y1="84" x2="54" y2="98" stroke="rgba(201,169,110,.35)" strokeWidth="1.5"/>
    <line x1="60" y1="82" x2="60" y2="100" stroke="rgba(201,169,110,.35)" strokeWidth="1.5"/>
    <line x1="66" y1="84" x2="66" y2="98" stroke="rgba(201,169,110,.35)" strokeWidth="1.5"/>
    <text x="60" y="168" textAnchor="middle" fontFamily="sans-serif" fontSize="9" fill="#c9a96e">{w}</text>
  </svg>
);

const beforeAfterMap = {
  'SR': { before: femaleBefore('68kg'), after: femaleAfter('58kg') },
  'DK': { before: maleBefore('98kg'), after: maleAfter('78kg') },
  'AL': { before: femaleBefore('72kg'), after: femaleAfter('62kg') },
  'TC': { before: maleBefore('88kg'), after: maleAfter('78kg') },
  'MK': { before: maleBefore('90kg'), after: maleAfter('82kg') },
  'ER': { before: femaleBefore('65kg'), after: femaleAfter('60kg') },
  'BT': { before: maleBefore('95kg'), after: maleAfter('80kg') },
  'LH': { before: femaleBefore('70kg'), after: femaleAfter('64kg') },
};

export default function Testimonials() {
  useReveal();
  useFloatBtn();

  const [filters, setFilters] = useState({ pkg: 'all', goal: 'all', gender: 'all' });

  const setFilter = (key, val) => setFilters(f => ({ ...f, [key]: val }));

  const filtered = allTestimonials.filter(t =>
    (filters.pkg === 'all' || t.pkg === filters.pkg) &&
    (filters.goal === 'all' || t.goal === filters.goal) &&
    (filters.gender === 'all' || t.gender === filters.gender)
  );

  return (
    <>
      {/* HERO */}
      <section id="hero">
        <div className="hero-bg"></div>
        <div className="hero-grid"></div>
        <div className="hero-liam">
          <div className="hero-liam-avatar">LW</div>
          <div className="hero-liam-text">
            <div className="hero-liam-name">Liam W Coaching</div>
            <div className="hero-liam-role">Level 4 Strength & Conditioning Coach · Bath, UK</div>
          </div>
        </div>
        <div className="hero-tag">
          <div className="hero-tag-line"></div>
          <span>Real Clients. Real Results. No Filters.</span>
        </div>
        <h1 className="hero-title">
          200+ LIVES<br />
          <span className="accent">TRANSFORMED.</span>
        </h1>
        <p className="hero-sub">Every result on this page came from a completely bespoke programme — no templates, no copy-paste. These are real people who committed and got real results.</p>
        <div className="hero-proof-row">
          {[{t:'200',s:'+',l:'Transformations'},{t:'4.9',s:'/5',l:'Average Rating'},{t:'98',s:'%',l:'Would Recommend'},{t:'12',s:'wk',l:'Avg. Visible Results'}].map(p => (
            <div className="proof-stat" key={p.l}>
              <div className="proof-num" data-t={p.t} data-s={p.s}>{p.t}{p.s}</div>
              <div className="proof-lbl">{p.l}</div>
            </div>
          ))}
        </div>
      </section>

      {/* FEATURED */}
      <div id="featured" className="rev">
        <div className="featured-card">
          <div className="featured-img-side">
            <BaSlider
              before={
                <svg viewBox="0 0 160 240" width="80%" height="80%" preserveAspectRatio="xMidYMid meet">
                  <defs><radialGradient id="skinMF"><stop offset="0%" stopColor="#c8956c"/><stop offset="100%" stopColor="#a0684a"/></radialGradient></defs>
                  <ellipse cx="80" cy="68" rx="30" ry="32" fill="url(#skinMF)"/>
                  <ellipse cx="80" cy="155" rx="46" ry="58" fill="#2a2020" opacity=".9"/>
                  <rect x="48" y="130" width="24" height="72" rx="6" fill="#2a2020"/>
                  <rect x="88" y="130" width="24" height="72" rx="6" fill="#2a2020"/>
                  <ellipse cx="80" cy="105" rx="46" ry="38" fill="#252020" opacity=".95"/>
                  <text x="80" y="228" textAnchor="middle" fontFamily="sans-serif" fontSize="11" fill="#666">92kg</text>
                </svg>
              }
              after={
                <svg viewBox="0 0 160 240" width="80%" height="80%" preserveAspectRatio="xMidYMid meet">
                  <defs><radialGradient id="skinMF2"><stop offset="0%" stopColor="#c8956c"/><stop offset="100%" stopColor="#a0684a"/></radialGradient></defs>
                  <ellipse cx="80" cy="66" rx="26" ry="29" fill="url(#skinMF2)"/>
                  <ellipse cx="80" cy="150" rx="34" ry="52" fill="#241a08" opacity=".9"/>
                  <rect x="56" y="130" width="18" height="70" rx="5" fill="#1e1408"/>
                  <rect x="86" y="130" width="18" height="70" rx="5" fill="#1e1408"/>
                  <ellipse cx="80" cy="103" rx="34" ry="30" fill="#201808" opacity=".95"/>
                  <line x1="72" y1="112" x2="72" y2="130" stroke="rgba(201,169,110,.4)" strokeWidth="2"/>
                  <line x1="80" y1="110" x2="80" y2="132" stroke="rgba(201,169,110,.4)" strokeWidth="2"/>
                  <line x1="88" y1="112" x2="88" y2="130" stroke="rgba(201,169,110,.4)" strokeWidth="2"/>
                  <text x="80" y="228" textAnchor="middle" fontFamily="sans-serif" fontSize="11" fill="#c9a96e">74kg</text>
                </svg>
              }
            />
          </div>
          <div className="featured-text-side">
            <div className="featured-badge">⭐ Featured Transformation</div>
            <div className="featured-stars">★★★★★</div>
            <p className="featured-quote">"I'd tried three different coaches before Liam. Every single one handed me a generic plan and disappeared. With FORGE, Liam was on WhatsApp with me daily — adjusting, coaching, pushing. I lost 18kg in 12 weeks and for the first time in years I actually understand my body. This isn't a service, it's a partnership."</p>
            <div className="featured-stats">
              <div className="feat-stat"><div className="feat-stat-num">−18kg</div><div className="feat-stat-lbl">Lost</div></div>
              <div className="feat-stat"><div className="feat-stat-num">−9%</div><div className="feat-stat-lbl">Body Fat</div></div>
              <div className="feat-stat"><div className="feat-stat-num">12wk</div><div className="feat-stat-lbl">Duration</div></div>
            </div>
            <div className="featured-author">
              <div className="fa-avatar">JM</div>
              <div>
                <div className="fa-name">James Mitchell, 34</div>
                <div className="fa-detail">FORGE · Online · Previously tried 3 other coaches</div>
              </div>
            </div>
          </div>
          <div className="featured-glow"></div>
        </div>
      </div>

      {/* FILTER */}
      <div id="filter-section">
        <div className="filter-bar">
          {[
            { label: 'Package', key: 'pkg', opts: [['all','All'],['ignite','IGNITE'],['forge','FORGE']] },
            { label: 'Goal', key: 'goal', opts: [['all','All'],['fatloss','Fat Loss'],['muscle','Muscle'],['recomp','Recomp']] },
            { label: 'Gender', key: 'gender', opts: [['all','All'],['male','Male'],['female','Female']] },
          ].map(({ label, key, opts }) => (
            <div className="filter-group" key={key}>
              <div className="filter-group-label">{label}</div>
              <div className="filter-btns">
                {opts.map(([val, lbl]) => (
                  <button key={val} className={`f-btn${filters[key] === val ? ' active' : ''}`} onClick={() => setFilter(key, val)}>{lbl}</button>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="results-count">Showing <span>{filtered.length}</span> results</div>
      </div>

      {/* MASONRY GRID */}
      <section id="testimonials-grid">
        <div className="masonry">
          {filtered.length === 0 && (
            <div className="no-results show">
              <div style={{ fontSize: 32, marginBottom: 16 }}>🔍</div>
              <h3>No results match your filters</h3>
              <p>Try adjusting the filters above to see more transformations.</p>
            </div>
          )}
          {filtered.map((t) => {
            const ba = beforeAfterMap[t.initials];
            return (
              <div className="t-card show" key={t.initials}>
                {ba && <BaSlider before={ba.before} after={ba.after} />}
                <div className="t-body">
                  <div className="t-top">
                    <div className="t-stars">{t.stars}</div>
                    <div className={`t-pkg ${t.pkg}`}>{t.pkg.toUpperCase()}</div>
                  </div>
                  <p className="t-quote">{t.quote}</p>
                  <div className="t-stats">
                    {t.stats.map(s => (
                      <div className="t-stat" key={s.l}><div className="t-stat-num">{s.n}</div><div className="t-stat-lbl">{s.l}</div></div>
                    ))}
                  </div>
                  <div className="t-author">
                    <div className="t-av">{t.initials}</div>
                    <div><div className="t-name">{t.name}</div><div className="t-detail">{t.detail}</div></div>
                  </div>
                </div>
                <div className="t-duration">{t.duration}</div>
              </div>
            );
          })}
        </div>
      </section>

      {/* CTA */}
      <section id="cta">
        <div className="cta-bg"></div>
        <div className="cta-inner">
          <div className="urgency rev"><div className="udot"></div><span>Limited spots — new intake opens monthly</span></div>
          <div className="s-label rev" style={{ justifyContent: 'center' }}><span>Your Transformation Starts Here</span></div>
          <h2 className="s-title rev">YOU COULD BE<br /><em style={{ color: 'var(--gold)', fontStyle: 'normal' }}>NEXT.</em></h2>
          <p className="rev">Every person on this page was exactly where you are right now — unsure, maybe sceptical, maybe having tried before. The only difference between them and you is that they applied.</p>
          <div className="cta-btns rev">
            <Link to="/packages" className="btn-gold">See the Packages →</Link>
            <Link to="/packages" className="btn-outline">Apply Now — It's Free</Link>
          </div>
        </div>
      </section>

      <Footer />
      <Link to="/packages" className="float-btn" id="floatBtn">Apply Now →</Link>
    </>
  );
}
